module.exports = __webpack_public_path__ + "img/folder.2769915b.svg";